// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/cargaService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import { paramsDaLista, type ListaFiltros, type PaginadoComResumo, type CargaListaResumo } from './listaFiltros';
import type {
  CargaResumo,
  CargaDetalhe,
  IniciarCargaRequest,
  AtualizarCargaRequest,
  RetornarCargaRequest,
} from '../types';

const BASE = '/api/cargas';

export const cargaService = {
  async getAll(pagina = 1, tamanhoPagina = 20, filtros: ListaFiltros = {}): Promise<PaginadoComResumo<CargaResumo, CargaListaResumo>> {
    const { data } = await apiClient.get<PaginadoComResumo<CargaResumo, CargaListaResumo>>(BASE, {
      params: paramsDaLista(pagina, tamanhoPagina, filtros),
    });
    return data;
  },

  async getAbertas(): Promise<CargaResumo[]> {
    const { data } = await apiClient.get<CargaResumo[]>(`${BASE}/abertas`);
    return data;
  },

  async getById(id: number): Promise<CargaDetalhe> {
    const { data } = await apiClient.get<CargaDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async iniciar(request: IniciarCargaRequest): Promise<CargaDetalhe> {
    const { data } = await apiClient.post<CargaDetalhe>(BASE, request);
    return data;
  },

  async update(id: number, request: AtualizarCargaRequest): Promise<CargaResumo> {
    const { data } = await apiClient.put<CargaResumo>(`${BASE}/${id}`, request);
    return data;
  },

  async registrarRetorno(id: number, request: RetornarCargaRequest): Promise<CargaDetalhe> {
    const { data } = await apiClient.put<CargaDetalhe>(`${BASE}/${id}/retorno`, request);
    return data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
